"use client";

import { Send } from "lucide-react";
import { cn } from "../../lib/utils";
import { SHARE_ACTION_BUTTON_CLASS_NAME } from "./share-action-buttons.constants";
import type { ShareActionButtonsProps } from "./share-action-buttons.types";

export function ShareActionButtons({
  shareLabel,
  whatsAppLabel,
  whatsAppIcon,
  onShare,
  onWhatsApp,
  whatsAppFirst = false,
  disabled = false,
  className,
  whatsAppClassName,
}: ShareActionButtonsProps) {
  const shareButton = (
    <button
      type="button"
      onClick={onShare}
      disabled={disabled}
      className={cn(
        SHARE_ACTION_BUTTON_CLASS_NAME,
        "shrink-0 bg-white text-[#101828]",
      )}
    >
      <Send aria-hidden="true" className="h-4 w-4" />
      {shareLabel}
    </button>
  );
  const whatsAppButton = (
    <button
      type="button"
      onClick={onWhatsApp}
      disabled={disabled}
      className={cn(
        SHARE_ACTION_BUTTON_CLASS_NAME,
        "min-w-0 flex-1 bg-primary text-primary-foreground",
        whatsAppClassName,
      )}
    >
      <span aria-hidden="true" className="shrink-0">
        {whatsAppIcon}
      </span>
      {whatsAppLabel}
    </button>
  );
  return (
    <div className={cn("flex items-center gap-3", className)}>
      {whatsAppFirst ? (
        <>
          {whatsAppButton}
          {shareButton}
        </>
      ) : (
        <>
          {shareButton}
          {whatsAppButton}
        </>
      )}
    </div>
  );
}
